import simpleLogoProvincia from '/assets/simpleLogoProvincia.svg'
export default function Contenido() {
    return(
      <div className={`h-full flex flex-col gap-y-8 items-center justify-center my-20`}>

      <div className="w-full h-full min-h-[600px] flex flex-col items-center justify-center gap-y-6">
        <img alt="provincia" className={'h-20 w-auto'} src={simpleLogoProvincia} />
        <h1 className="text-gray-secondary text-3xl">{'Es una página de ejemplo'}</h1>
        <button
          onClick={() => {
            throw new Error('Error de ejemplo')
          }}
          className="bg-red-600 text-white px-4 py-2 rounded-md"
        >
          {'Probar Sentry'}
        </button>
      </div>
    </div>
    )
}